import { IAudioPayload } from 'redux/reducers/audioReducer';
import { ActionTypes } from 'constants/actionTypes';
import { IBooksDetailData } from 'constants/types';

export const setAudioStatus = (payload: IAudioPayload['status']) => ({
  type: `${ActionTypes.AUDIO}_STATUS`,
  payload,
});

export const setAudioLoading = (payload: IAudioPayload['loading']) => ({
  type: `${ActionTypes.AUDIO}_LOADING`,
  payload,
});

export const setAudioData = (payload: IBooksDetailData) => {
  const payloadData: IAudioPayload['data'] = {
    name: payload?.name,
    id: payload?.bookId,
    preview: payload?.abookPreview || payload?.ebookPreview,
    authors: payload?.authors,
    list: payload?.aFiles,
  };

  return {
    type: `${ActionTypes.AUDIO}_DATA`,
    payload: payloadData,
  };
};

export const setAudioCurrentTime = (payload: IAudioPayload['time']['current']) => ({
  type: `${ActionTypes.AUDIO}_CURRENT_TIME`,
  payload,
});

export const setAudioTotalTime = (payload: IAudioPayload['time']['total']) => ({
  type: `${ActionTypes.AUDIO}_TOTAL_TIME`,
  payload,
});

export const setAudioPlaybackRate = (payload: IAudioPayload['time']['playbackRate']) => ({
  type: `${ActionTypes.AUDIO}_PLAYBACK_RATE_TIME`,
  payload,
});

export const setAudioCurrentIndex = (payload: IAudioPayload['current']['index']) => ({
  type: `${ActionTypes.AUDIO}_CURRENT_INDEX`,
  payload,
});

export const setAudioClear = () => ({
  type: `${ActionTypes.AUDIO}_CLEAR`,
});
